<!-- Mobile backdrop -->
@if (mobileOpen()) {
  <div class="fixed inset-0 bg-black/40 z-30 md:hidden" (click)="closeMobile()"></div>
}

<!-- Mobile hamburger button -->
<button
  (click)="toggleMobile()"
  class="fixed top-4 z-50 md:hidden p-2 rounded-lg bg-white border border-stone-200 shadow-sm transition-[left] duration-300"
  [style.left]="mobileOpen() ? 'calc(16rem + 0.75rem)' : '0.75rem'"
  [attr.aria-expanded]="mobileOpen()"
  aria-label="Menu"
  title="Menu"
>
  <svg class="w-5 h-5 text-stone-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    @if (mobileOpen()) {
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    } @else {
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    }
  </svg>
</button>

<aside
  class="fixed left-0 top-0 bottom-0 min-h-dvh h-screen transition-all duration-300 z-40 flex flex-col"
  [style.backgroundColor]="isFederationView ? '#1f2937' : 'rgb(233, 233, 222)'"
  [class.text-stone-800]="!isFederationView"
  [class.w-64]="isOpen()"
  [class.w-20]="!isOpen()"
  [class.sidebar-mobile-open]="mobileOpen()"
  [class.federation-view]="isFederationView"
>
  <!-- Sidebar Header with Club Logo & Name -->
  <div [style.padding]="'12px'" [style.height]="'4.5rem'" [style.backgroundColor]="isFederationView ? '' : ''" class="border-b border-stone-300 flex items-center">
    @if (club()) {
      <div class="flex items-center gap-3">
        <!-- Club Logo -->
        <div class="h-12 w-12 flex items-center flex-shrink-0">
          @if (club()?.logo_club && club()!.logo_club !== logoFailedUrl()) {
            <img [src]="club()!.logo_club" alt="Club logo" class="h-full w-full rounded-lg object-cover" (error)="logoFailedUrl.set(club()!.logo_club ?? null)" />
          } @else {
            <div class="h-full w-full rounded-lg bg-primary-500 flex items-center justify-center">
              <span class="text-white font-bold text-sm">{{ (club()?.club_name || '').charAt(0) }}</span>
            </div>
          }
        </div>
        <!-- Club Name -->
        @if (isOpen() && club()?.club_name) {
          <h2 class="text-sm font-semibold truncate flex-1" [class.text-stone-800]="!isFederationView" [style.color]="isFederationView ? '#334155' : ''">{{ club()!.club_name }}</h2>
        }
      </div>
    } @else if (federation() && isOpen()) {
      <div class="w-full flex items-center justify-center">
        <img src="assets/images/sportiq-logo-v2.png" alt="SportIQ" [style.height]="'3rem'" class="object-contain" />
      </div>
    } @else {
      @if (isOpen()) {
        <h2 class="text-base font-semibold text-center">Menu</h2>
      }
    }
  </div>

  <!-- Toggle Button - Always visible, floating outside -->
  <button
    (click)="toggleSidebar()"
    class="absolute top-20 -right-5 p-2 rounded-lg transition-all z-50 hidden md:block"
    style="border: 3px solid #fafbf6;"
    [style.backgroundColor]="isFederationView ? '#111827' : '#d0d9c7'"
    [style.color]="'#fafbf6'"
    title="Afficher / masquer le menu"
  >
    <svg class="w-4 h-4 transition-transform" [style.stroke]="isFederationView ? '#fafbf6' : '#fafbf6'" [style.transform]="!isOpen() ? 'scaleX(-1)' : 'scaleX(1)'" fill="none" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <!-- Menu Items -->
  <nav class="flex-1 px-3 py-6 space-y-2 overflow-y-auto">
    @if (isOpen()) {
      @if (isFederationView) {
        <div class="space-y-2">
          @for (item of menuItems(); track item.label) {
            @if (!item.children || item.children.length === 0) {
              <!-- Item standalone -->
              <button
                (click)="navigateTo(item)"
                class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
                [class.bg-primary-50]="isActive(item.route)"
                [class.text-primary-600]="isActive(item.route)"
                [title]="item.label"
              >
                <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                  [class.bg-primary-500]="!isActive(item.route)"
                  [class.bg-primary-100]="isActive(item.route)">
                  <span class="material-icons text-sm">{{ item.icon }}</span>
                </span>
                <span class="text-sm font-medium truncate">{{ item.label }}</span>
              </button>
            } @else {
              <!-- Item accordéon -->
              <div>
                <button
                  (click)="toggleDropdown(item.label)"
                  class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
                  [class.bg-primary-50]="isParentActive(item)"
                  [class.text-primary-600]="isParentActive(item)"
                  [title]="item.label"
                >
                  <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                    [class.bg-primary-500]="!isParentActive(item)"
                    [class.bg-primary-100]="isParentActive(item)">
                    <span class="material-icons text-sm">{{ item.icon }}</span>
                  </span>
                  <span class="text-sm font-medium truncate">{{ item.label }}</span>
                  <svg class="w-4 h-4 transition-transform duration-200 ml-auto"
                    [style.transform]="isItemExpanded(item) ? 'rotate(180deg)' : 'rotate(0deg)'"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7" />
                  </svg>
                </button>
                @if (isItemExpanded(item)) {
                  <div class="ml-4 mt-1 space-y-1 border-l border-stone-300 pl-3">
                    @for (child of item.children; track child.label) {
                      <button
                        (click)="navigateTo(child)"
                        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-sm"
                        [class.bg-primary-50]="isChildActive(child.route)"
                        [style.color]="isChildActive(child.route) ? '#e11d48' : child.badgeDot === 'open' ? '#10b981' : '#9ca3af'"
                        [title]="child.label"
                      >
                        <span class="flex-shrink-0 w-4 h-4 flex items-center justify-center">
                          <span class="material-icons" style="font-size: 16px;">{{ child.icon }}</span>
                        </span>
                        <span class="truncate">{{ child.label }}</span>
                        @if (child.badgeDot) {
                          <span class="relative flex h-2 w-2 ml-auto flex-shrink-0">
                            @if (child.badgeDot === 'open') {
                              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                              <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                            } @else {
                              <span class="relative inline-flex rounded-full h-2 w-2 bg-stone-300"></span>
                            }
                          </span>
                        }
                      </button>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      } @else {
        <!-- Section: Accueil Items (items without children) -->
        <div class="space-y-2">
          @for (item of menuItems(); track item.label) {
            @if (!item.children || item.children.length === 0) {
              <!-- Non-clickable label (empty route) -->
              @if (item.route === '' || item.route === undefined) {
                <div class="px-4 py-3 text-sm font-medium" [class.text-stone-600]="!isFederationView">{{ item.label }}</div>
              } @else {
                <!-- Clickable button -->
                <button
                  (click)="navigateTo(item)"
                  class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
                  [class.bg-stone-100]="!isFederationView && isActive(item.route)"
                  [class.bg-primary-50]="isFederationView && isActive(item.route)"
                  [class.text-stone-800]="!isFederationView && isActive(item.route)"
                  [class.text-primary-600]="isFederationView && isActive(item.route)"
                  [title]="item.label"
                >
                  <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                    [class.bg-primary-500]="!isActive(item.route)"
                    [class.bg-primary-100]="isActive(item.route)">
                    <span class="material-icons text-sm">{{ item.icon }}</span>
                  </span>
                  <span class="text-sm font-medium truncate">{{ item.label }}</span>
                </button>
              }
            }
          }
        </div>

        <!-- Section Header: Gestion -->
        <div class="px-4">
          <p class="text-xs font-bold uppercase tracking-widest" [class.text-stone-600]="!isFederationView">Gestion</p>
        </div>

        <!-- Section: Gestion Items (items with children) -->
        <div class="space-y-2">
          @for (item of menuItems(); track item.label) {
            @if (item.children && item.children.length > 0) {
              <!-- Parent Item with Dropdown -->
              <div>
                <button
                  (click)="toggleDropdown(item.label)"
                  class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
                  [class.bg-stone-100]="!isFederationView && isParentActive(item)"
                  [class.bg-primary-50]="isFederationView && isParentActive(item)"
                  [class.text-stone-800]="!isFederationView && isParentActive(item)"
                  [class.text-primary-600]="isFederationView && isParentActive(item)"
                  [title]="item.label"
                >
                  <!-- Icon -->
                  <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                    [class.bg-primary-500]="!isParentActive(item)"
                    [class.bg-primary-100]="isParentActive(item)">
                    <span class="material-icons text-sm">{{ item.icon }}</span>
                  </span>
                  <!-- Label -->
                  <span class="text-sm font-medium truncate">{{ item.label }}</span>
                  <!-- Chevron Icon - Arrow Down/Up Angle -->
                  <svg class="w-4 h-4 transition-transform duration-200 ml-auto"
                    [style.transform]="isItemExpanded(item) ? 'rotate(180deg)' : 'rotate(0deg)'"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7" />
                  </svg>
                </button>

                <!-- Children Items -->
                @if (isItemExpanded(item)) {
                  <div class="ml-4 mt-1 space-y-1 border-l border-stone-300 pl-3">
                    @for (child of item.children; track child.label) {
                      <button
                        (click)="navigateTo(child)"
                        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-sm"
                        [class.bg-primary-50]="isChildActive(child.route)"
                        [style.color]="isChildActive(child.route) ? '#ed918d' : child.badgeDot === 'open' ? '#10b981' : '#6b7c5a'"
                        [title]="child.label"
                      >
                        <!-- Child Icon -->
                        <span class="flex-shrink-0 w-4 h-4 flex items-center justify-center">
                          <span class="material-icons" style="font-size: 16px;">{{ child.icon }}</span>
                        </span>
                        <!-- Label -->
                        <span class="truncate">{{ child.label }}</span>
                        @if (child.badgeDot) {
                          <span class="relative flex h-2 w-2 ml-auto flex-shrink-0">
                            @if (child.badgeDot === 'open') {
                              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                              <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                            } @else {
                              <span class="relative inline-flex rounded-full h-2 w-2 bg-stone-300"></span>
                            }
                          </span>
                        }
                      </button>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    }

    <!-- Section: Utils — only rendered when there's actually a guide item to show (e.g. no
         Formulaires link for a role without formulaires:read), so a narrow role's sidebar never
         ends in an orphaned "UTILE" header with nothing underneath it. -->
    @if (isOpen() && guideItems().length > 0) {
      <div>
        <p class="text-xs font-bold uppercase tracking-widest px-4 mb-3" [class.text-stone-600]="!isFederationView">Utile</p>
        <div class="space-y-2">
          @for (item of guideItems(); track item.route) {
            <button
              (click)="navigateTo(item)"
              class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 "
              [class.bg-stone-100]="!isFederationView && isActive(item.route)"
              [class.bg-primary-50]="isFederationView && isActive(item.route)"
              [class.text-stone-800]="!isFederationView && isActive(item.route)"
              [class.text-primary-600]="isFederationView && isActive(item.route)"
              [title]="item.label"
            >
              <!-- Icon -->
              <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                [class.bg-primary-500]="!isActive(item.route)"
                [class.bg-primary-100]="isActive(item.route)">
                <span class="material-icons text-sm">{{ item.icon }}</span>
              </span>
              <!-- Label -->
              <span class="text-sm font-medium truncate">{{ item.label }}</span>
            </button>
          }
        </div>
      </div>
    }

    <!-- Collapsed View Icons Only -->
    @if (!isOpen()) {
      <div class="space-y-3 mt-8">
        @if (isFederationView) {
          @for (item of menuItems(); track item.label) {
            @if (!item.children || item.children.length === 0) {
              @if (item.route && item.route !== '') {
                <button
                  (click)="navigateTo(item)"
                  class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 "
                  [class.bg-stone-100]="isActive(item.route)"
                  [class.text-stone-800]="isActive(item.route)"
                  [title]="item.label"
                >
                  <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                    [class.bg-primary-500]="!isActive(item.route)"
                    [class.bg-primary-100]="isActive(item.route)">
                    <span class="material-icons text-sm">{{ item.icon }}</span>
                  </span>
                </button>
              }
            } @else {
              @for (child of item.children; track child.label) {
                <button
                  (click)="navigateTo(child)"
                  class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 "
                  [class.bg-stone-100]="isActive(child.route)"
                  [class.text-stone-800]="isActive(child.route)"
                  [title]="child.label"
                >
                  <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
                    [class.bg-primary-500]="!isActive(child.route)"
                    [class.bg-primary-100]="isActive(child.route)">
                    <span class="material-icons text-sm">{{ child.icon }}</span>
                  </span>
                </button>
              }
            }
          }
        } @else {
          @for (item of menuItems(); track item.route) {
            <button
              (click)="navigateTo(item)"
              class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 "
              [class.bg-stone-100]="isActive(item.route)"
              [class.text-stone-800]="isActive(item.route)"
              [title]="item.label"
            >
            <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
              [class.bg-primary-500]="!isActive(item.route)"
              [class.bg-primary-100]="isActive(item.route)">
              <span class="material-icons text-sm">{{ item.icon }}</span>
            </span>
          </button>
          }
        }
        <!-- Guide items icons in collapsed view -->
        @for (item of guideItems(); track item.route) {
          <button
            (click)="navigateTo(item)"
            class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 "
            [class.bg-stone-100]="isActive(item.route)"
            [class.text-stone-800]="isActive(item.route)"
            [title]="item.label"
          >
            <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-white"
              [class.bg-primary-500]="!isActive(item.route)"
              [class.bg-primary-100]="isActive(item.route)">
              <span class="material-icons text-sm">{{ item.icon }}</span>
            </span>
          </button>
        }
      </div>
    }
  </nav>

  <!-- Footer: Version -->
  <div class="border-t border-stone-300 px-3 py-4">
    @if (isOpen()) {
      <div class="px-4 py-2 text-center">
        <p class="text-xs text-stone-600">Version {{ version() }}</p>
      </div>
    }
  </div>
</aside>

<!-- Main Content Offset (desktop only) -->
<div
  class="transition-all duration-300 hidden md:block flex-shrink-0"
  [class.md:w-64]="isOpen()"
  [class.md:w-20]="!isOpen()"
  [style.backgroundColor]="isFederationView ? '#1f2937' : 'rgb(233, 233, 222)'"
></div>
